export var getItem = function getItem(key) {
  var res = localStorage.getItem(key);
  try {
    return res && JSON.parse(res);
  } catch (e) {
    console.error('localstorage: json parse error', e);
    return res;
  }
};
export var setItem = function setItem(key, value) {
  if (key) {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    console.error('localstorage: key is required');
  }
  return value;
};
export var deleteItem = function deleteItem(key) {
  localStorage.removeItem(key);
};
export var themeModeKey = 'arco-themes-thememode';